import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { routesPaths, IRoutePaths } from "./routes/routes";
import "./App.css";
function App() {
  return (
    <Router>
      <Routes>
        {routesPaths.map((route: IRoutePaths) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
